import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_HOST } from "../../constants";

import BbsCard from "./BbsCard";
import LoadingAnime from "../Common/LoadingAnime";
import { Helmet } from "react-helmet-async";

function BbsMain() {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_HOST}/api/grouped-bbs/`)
      .then((response) => {
        setCards(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <LoadingAnime label="커뮤니티 현황 로딩 중..." />;
  }

  return (
    <>
      <Helmet>
        <title>세상의 모든이야기 - 썰모</title>
      </Helmet>
      <div className="space-y-6">
        {/* <section className="glass-card p-6 sm:p-8">
          <div className="flex flex-col gap-2">
            <p className="text-xs uppercase tracking-[0.4em] text-ink-200">SSULMO COMMUNITY</p>
            <h1 className="font-display text-3xl text-white sm:text-4xl">오늘의 썰을 모아봤어요</h1>
            <p className="text-sm text-ink-200">
              최신 게시글과 핫한 토픽을 한눈에 확인하세요. 관리자 패널에서 더 많은 관리 기능을 사용할 수 있습니다.
            </p>
          </div>
        </section> */}

        <div className="grid gap-6 lg:grid-cols-2">
          {cards.map((card, index) => (
            <BbsCard key={index} title={card.title} items={card.items} module_name={card.module_name} module_url={card.url} />
          ))}
        </div>
      </div>
    </>
  );
}

export default BbsMain;
